// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quoteCard{height:100px!important}.quoteCard .v-icon{font-size:4.5em}.quoteCard span{font-size:1.2em}.quoteCard.cardActive{background-color:#009688!important;color:#fff!important}.quoteCard.cardActive .v-icon{color:#fff!important}.quoteCard:hover{cursor:pointer;color:#009688}.quoteCard:hover .v-icon{color:#009688}", ""]);
// Exports
module.exports = exports;
